import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	toolbar: {
		display: "flex",
		justifyContent: "space-between",
		backgroundColor: tokens.colorNeutralBackground1,
		borderBottom: `1px solid ${tokens.colorNeutralStroke1}`,
		padding: "0 8px 0 18px",
	},
	logo: {
		width: "44px",
	},
	container: {
		display: "flex",
		gap: "6px",
		alignItems: "center"
	},
	h2: {
		fontWeight: tokens.fontWeightSemibold,
		color: tokens.colorNeutralForeground1,
	},
});
